import React from 'react';
import PropTypes from 'prop-types';

import IconCaliforniaFlag from 'components/icons/iconCaliforniaFlag';
import { withState } from './state';
import DSRForm from './components/DSRForm';
import DSRSuccess from './components/DSRSuccess';

const DSRPage = props => {
  const { state } = props;

  return (
    <div className="md:px-0 md:py-4 md:bg-gray-light9">
      <div className="max-w-[800px] my-16 mx-auto py-12 px-24 bg-white max-md:p-4 max-md:my-4 max-md:mx-auto">
        <div className="md:text-center">
          <IconCaliforniaFlag />
        </div>
        {state.isSuccess ? (
          <DSRSuccess />
        ) : (
          <>
            <div className="md:text-center">
              <h1 className="text-4xl text-gray font-bold mb-4">
                Your data is protected, and in your control.{' '}
              </h1>
              <h3 className="text-lg text-gray font-bold">
                Joybird is committed to data protection and privacy laws.{' '}
              </h3>
              <h4 className="text-base text-gray font-bold">
                The California Consumer Privacy Act (CCPA) is a new data privacy
                law that came into effect on January 1, 2020. If you’re a
                California resident, you can use the form below to request
                access to, or the deletion of, any of your personal information
                we may have collected.
              </h4>
            </div>
            <DSRForm state={state} actions={props.actions} />
          </>
        )}
      </div>
    </div>
  );
};

DSRPage.propTypes = {
  actions: PropTypes.object,
  state: PropTypes.object,
};

export default withState(DSRPage);
